import apiClient, { ApiResponse } from "./client";
import { config } from "../config";
import type { LanguageCertificate } from "./language-certificates";
import { notify } from "../utils/toast";

export type GdqPCertificate = LanguageCertificate;

export const gdqpCertificatesApi = {
    // Fetch a single GDQP certificate by ID.
    getById: async (id: string, field?: string, log: boolean = true): Promise<ApiResponse<GdqPCertificate>> => {
        try {
            const response = await apiClient.get<GdqPCertificate>(
                `${config.endpoints.gdqpCertificates}/${id}?field=${field}`
            );
            return response;
        } catch (error) {
            if (error instanceof Error && log) {
                notify.error(error.message);
            }
            // Backward-compatible fallback while backend endpoint is being separated.
            return await apiClient.get<GdqPCertificate>(
                `${config.endpoints.languageCertificates}/${id}`
            );
        }
    },
};
